module.exports = __webpack_public_path__ + "02_long_gold.f3271315.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/02_long_gold.png
// module id = 2N6F
// module chunks = 0